import { graphql } from 'gql/generated'

export const CREATE_ROUTING_PROJECT = graphql(`
  mutation CreateRoutingProject($input: CreateRoutingProjectInput!) {
    createRoutingProject(input: $input) {
      id
    }
  }
`)

export const CHANGE_ROUTING_PROJECT = graphql(`
  mutation ChangeRoutingProject($input: ChangeRoutingProjectInput!) {
    changeRoutingProject(input: $input)
  }
`)

export const CREATE_ROUTING_PROJECT_DATASET = graphql(`
  mutation CreateRoutingProjectDataset($input: CreateRoutingProjectDatasetInput!) {
    createRoutingProjectDataset(input: $input) {
      id
    }
  }
`)

export const CREATE_ROUTING_PROJECT_PLAN = graphql(`
  mutation CreateRoutingProjectPlan($input: CreateRoutingProjectPlanInput!) {
    createRoutingProjectPlan(input: $input) {
      id
    }
  }
`)

export const CHANGE_ROUTING_PROJECT_PLAN_CONSTRAINTS = graphql(`
  mutation ChangeRoutingProjectPlanConstraints($input: ChangeRoutingProjectPlanConstraintsInput!) {
    changeRoutingProjectPlanConstraints(input: $input)
  }
`)

export const CREATE_ROUTING_PROJECT_PLAN_OPTIMIZATION = graphql(`
  mutation CreateRoutingProjectPlanOptimization($input: CreateRoutingProjectPlanOptimizationInput!) {
    createRoutingProjectPlanOptimization(input: $input)
  }
`)

export const CHANGE_ROUTING_PROJECT_PLAN_DATASET_LOCATIONS = graphql(`
  mutation ChangeRoutingProjectPlanDatasetLocations($input: ChangeRoutingProjectPlanDatasetLocationsInput!) {
    changeRoutingProjectPlanDatasetLocations(input: $input)
  }
`)

export const CHANGE_ROUTING_PROJECT_PLAN_OPTIMIZATION_ROUTE_STOPS = graphql(`
  mutation ChangeRoutingProjectPlanOptimizationRouteStops(
    $input: ChangeRoutingProjectPlanOptimizationRouteStopsInput!
  ) {
    changeRoutingProjectPlanOptimizationRouteStops(input: $input)
  }
`)

export const REMOVE_ROUTING_PROJECT_PLAN_DATASET_LOCATIONS = graphql(`
  mutation RemoveRoutingProjectPlanDatasetLocations($input: RemoveRoutingProjectPlanDatasetLocationsInput!) {
    removeRoutingProjectPlanDatasetLocations(input: $input)
  }
`)

export const ADD_ROUTING_PROJECT_PLAN_DATASET_LOCATIONS = graphql(`
  mutation AddRoutingProjectPlanDatasetLocations($input: AddRoutingProjectPlanDatasetLocationsInput!) {
    addRoutingProjectPlanDatasetLocations(input: $input) {
      locations {
        id
      }
    }
  }
`)
